import { useAppStore } from '@/stores/app'
import { chatSidebarMaxWidth } from '@/stores/app/chatSidebarSlice'
import { useMountEffect } from '@/hooks/useMountEffect'
import { CHAT_SIDEBAR_MIN_WIDTH_PX } from '@/config/constants'

// Mount-time + resize-driven width clamp. Mount-time call catches
// rehydrated widths that exceed the current viewport (persist bypasses
// the slice clamp). Resize listener handles window-shrink mid-session — and
// also a WIDEN that crosses into the xl tier, where the panel becomes an
// inline column and the ceiling tightens even though the viewport grew.
export function useViewportChatSidebarClamp() {
  useMountEffect(() => {
    const clampToViewport = () => {
      const max = chatSidebarMaxWidth()
      const current = useAppStore.getState().chatSidebar.width
      if (current > max) {
        useAppStore
          .getState()
          .setChatSidebarWidth(Math.max(CHAT_SIDEBAR_MIN_WIDTH_PX, max))
      }
    }
    clampToViewport()
    let timeout: number | undefined
    const onResize = () => {
      if (timeout) clearTimeout(timeout)
      timeout = window.setTimeout(clampToViewport, 100)
    }
    window.addEventListener('resize', onResize)
    return () => {
      window.removeEventListener('resize', onResize)
      if (timeout) clearTimeout(timeout)
    }
  })
}
